// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__mTbTV","inputDescription":"styles_inputDescription__AeA3S"};